<script setup lang="ts">
  import { useApiRequestsAbort } from '@/shared/composables'
  import { computed, defineAsyncComponent } from 'vue'
  import { useFeaturesStore } from '@/shared/store/featuresStore'

  const FlowSelectPlanInboundWidget = defineAsyncComponent(
    () => import('@/widgets/Flow/FlowSelectPlanInboundWidget/FlowSelectPlanInboundWidget.vue')
  )
  const FlowSelectPlanInboundWidgetQC = defineAsyncComponent(
    () => import('@/widgets/Flow/FlowSelectPlanInboundWidgetQC/FlowSelectPlanInboundWidgetQC.vue')
  )

  const featuresStore = useFeaturesStore()
  const isSelectPlanInboundQCEnabled = computed(() => featuresStore.isSelectPlanInboundQCEnabled)
  useApiRequestsAbort()
</script>

<template>
  <FlowSelectPlanInboundWidgetQC v-if="isSelectPlanInboundQCEnabled" />
  <FlowSelectPlanInboundWidget v-else />
</template>
